'use client';

import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import CreateRouteButton from './CreateRouteButton';
import { HeaderBackground } from './types';

type NavCreateRouteButtonProps = {
  background: HeaderBackground;
};

const NavCreateRouteButton = ({ background }: NavCreateRouteButtonProps) => {
  const experiments = useExperiments();
  const navCreateXPValue = experiments['web-disco-rm-nav-create']?.value ?? 'control';

  if (navCreateXPValue !== 'button-secondary' && navCreateXPValue !== 'button-tertiary') {
    return null;
  }

  const variant = navCreateXPValue === 'button-secondary' ? 'secondary' : 'tertiary';

  if (background === 'transparent-inverted') {
    return (
      <div data-at-theme-colors="dark">
        <CreateRouteButton variant={variant} />
      </div>
    );
  }

  return <CreateRouteButton variant={variant} />;
};

export default NavCreateRouteButton;
